// extracted by mini-css-extract-plugin
module.exports = {"button":"button__1xaS_","text":"text__1ew6v"};